import {System} from './System'

const codeColumns = [
    { field: 'value',             headerName: 'Beschreibung',     type: 'string',  width: 300, sortable: true },
    { field: 'refLabel',          headerName: 'SORBA Nr.',        type: 'string',  width: 160, sortable: true },
    { field: 'activeLabel',       headerName: 'Aktiv',            type: 'string',  width: 100, sortable: true },
    { field: 'quantity',          headerName: 'Anzahl',           type: 'number',  width: 100, sortable: true },
    { field: 'warrantyLabel',     headerName: 'Garantie',         type: 'string',  width: 100, sortable: true },
    { field: 'pumpLabel',         headerName: 'Pumpe',            type: 'string',  width: 100, sortable: true },
    { field: 'materialListLabel', headerName: 'Bestellliste',     type: 'string',  width: 100, sortable: true },
    { field: 'clearingListLabel', headerName: 'Abräumliste',      type: 'string',  width: 100, sortable: true },
    { field: 'key',               headerName: 'Key',              type: 'string',  width: 100, sortable: true },
    { field: 'order',             headerName: 'Order',            type: 'number',  width: 100, sortable: true },
]

const codeColumnsMap = Object.fromEntries(codeColumns.map(col => [col.field, col]));

export const Code = {

    getFormValues(key, order) {
        return {
            key           : key,
            value         : "",
            ref           : "",
            active        : 1,
            order         : order,
            quantity      : 0,
            warranty      : 0,
            pump          : 0,
            material_list : 0,
            clearing_list : 0
        }
    },

    getFormErrors() {
        return System.initializeFormErrors(this.getFormValues());
    },

    getFormRequiredFields(showQuantity) {
        return showQuantity ? ["value", "quantity"] : ["value"];
    },

    mapFormToDb(formValues) {
        return {
            key           : formValues.key,
            value         : formValues.value,
            ref           : formValues.ref,
            active        : formValues.active,
            order         : formValues.order,
            quantity      : formValues.quantity,
            warranty      : formValues.warranty,
            pump          : formValues.pump,
            material_list : formValues.material_list,
            clearing_list : formValues.clearing_list,
            version       : formValues.version
        }
    },

    getListColumns(cfg) {
        const fields = ['value'];

        if (cfg.showRef)          fields.push('refLabel');
        if (cfg.showQuantity)     fields.push('quantity');
        if (cfg.showWarranty)     fields.push('warrantyLabel');
        if (cfg.showPump)         fields.push('pumpLabel');
        if (cfg.showMaterialList) fields.push('materialListLabel');
        if (cfg.showClearingList) fields.push('clearingListLabel');

        fields.push('activeLabel', 'key', 'order');

        return fields.map(f => codeColumnsMap[f]).filter(Boolean);
    },

    getListValues(items) {

        return items.map(item => {
            const refLabel = item.ref ? item.ref : 'Keine';
            const activeLabel = item.active ? 'Ja' : 'Nein';
            const warrantyLabel = item.warranty ? 'Ja' : 'Nein';
            const pumpLabel = item.pump ? 'Ja' : 'Nein';
            const materialListLabel = item.material_list ? 'Ja' : 'Nein';
            const clearingListLabel = item.clearing_list ? 'Ja' : 'Nein';

            return {
                ...item,
                refLabel          : refLabel,
                activeLabel       : activeLabel,
                warrantyLabel     : warrantyLabel,
                pumpLabel         : pumpLabel,
                materialListLabel : materialListLabel,
                clearingListLabel : clearingListLabel
            };
        });
    }

}